<div
  class="component-container text-cool-grey h-[100%] flex flex-col justify-center items-center p-[4rem]">
  <div class="consent-form-container md:w-[80%] w-full flex flex-col justify-center items-center">
    <app-step-progress-indicator
      [currentStep]="4"
      [totalSteps]="5"
    ></app-step-progress-indicator>
    <div *ngIf="userRole === roles['participant']; else otherRole">
      <div class="heading font-poppins font-bold mb-[2.4rem] flex justify-center text-center">
        Assent Form
      </div>
    </div>

  <ng-template #otherRole>
    <div class="heading font-poppins font-bold mb-[2.4rem] flex justify-center text-center">
      Required Consent Forms
    </div>
  </ng-template>
<!--  <div class="message font-work-sans font-normal">-->
<!--    Please access the link below to review and sign your confidentiality agreement to complete registration.-->
<!--  </div>-->
<!--  <div-->
<!--    class="link font-work-sans font-normal"-->
<!--    (click)="linkClick()"-->
<!--  >-->
<!--    {{consentFormLink}}-->
<!--  </div>-->
  <div class="action-section mt-[2.4rem] flex flex-col items-center">
    <app-primary-button
      type="small"
      class="continue-btn w-[70%] flex justify-center"
      (handleClick)="linkClick()">
      CONTINUE
    </app-primary-button>
  </div>
  </div>
</div>

